(() => {
  let salesmenInputDebounce;

  let copyToClipboardFunction;

  const whatsappText =
    "¡Entra a la Tienda Virtual de Milagros y empieza a comprar!\r\n";

  const caret = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-caret" fill="none" viewBox="0 0 24 15">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15c-.3 0-.6-.1-.8-.4l-11-13C-.2 1.2-.1.5.3.2c.4-.4 1.1-.3 1.4.1L12 12.5 22.2.4c.4-.4 1-.5 1.4-.1.4.4.5 1 .1 1.4l-11 13c-.1.2-.4.3-.7.3z" fill="currentColor"/>
    </svg>`;

  function addSalesmanToShopifyAttribute(salesmanDocument, salesmanCode) {
    const formData = new FormData();
    formData.append("attributes[salesman]", salesmanDocument);

    fetch(`/discount/CLEAR}`).then(() => {
      if (salesmanDocument) {
        fetch(`/discount/${salesmanCode}`).then(() => {
          fetch("/cart/update.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error("Error adding salesman to cart");
              }
              return response.json();
            })
            .then((data) => {
              localStorage.setItem("blockGetSalesmanFromLastPurchase", true);
              location.reload();
            })
            .catch((error) => {
              console.error("Error adding salesman to cart", error);
            });
        });
      } else {
        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Error adding salesman to cart");
            }
            return response.json();
          })
          .then((data) => {
            location.reload();
          })
          .catch((error) => {
            console.error("Error adding salesman to cart", error);
          });
      }
    });
  }

  function getSalesmanAttributeFromShopify() {
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error getting cart");
        }
        return response.json();
      })
      .then((data) => {
        const salesmanAttribute = data.attributes.salesman;
        const selectedSalesman = getSalesmanFromLocalStorage();

        if (
          !selectedSalesman &&
          (!salesmanAttribute ||
            salesmanAttribute === "" ||
            salesmanAttribute === "undefined")
        ) {
          return;
        }

        if (!selectedSalesman) {
          addSalesmanToShopifyAttribute(undefined);
          return;
        }

        if (
          !salesmanAttribute ||
          salesmanAttribute !== selectedSalesman.document
        ) {
          addSalesmanToShopifyAttribute(
            selectedSalesman.document,
            selectedSalesman.code
          );
        }
      })
      .catch((error) => {
        console.error("Error getting cart", error);
      });
  }

  function setupSharedSalesman() {
    const shareLink = document.querySelector(".salesman__share__link");
    const whatsappLink = document.querySelector(".salesman__share__whatsapp");
    const shareLinkText = document.querySelector(".salesman__share__link span");
    const copySuccessIcon = document.querySelector(
      ".salesman__share__link .icon-success"
    );
    const copyIcon = document.querySelector(
      ".salesman__share__link .icon-copy"
    );

    const salesmanSelected = getSalesmanFromLocalStorage();

    if (salesmanSelected) {
      const linkToShare =
        window.location.origin + `/?empresario=${salesmanSelected.document}`;

      whatsappLink.href = `https://wa.me/?text=${encodeURIComponent(
        whatsappText + linkToShare
      )}`;

      shareLinkText.innerHTML = linkToShare;
      if (copyToClipboardFunction) {
        shareLink.removeEventListener("click", copyToClipboardFunction);
      }

      copyToClipboardFunction = () => {
        navigator.clipboard.writeText(linkToShare);
        copySuccessIcon.style.display = "block";
        copyIcon.style.display = "none";

        setTimeout(() => {
          copySuccessIcon.style.display = "none";
          copyIcon.style.display = "block";
        }, 2000);
      };

      shareLink.addEventListener("click", copyToClipboardFunction);
    }
  }

  function openSalesmanModal() {
    const modal = document.querySelector(".salesman__modal");
    modal.classList.remove("salesman__modal--close");
  }

  function closeSalesmanModal() {
    const modal = document.querySelector(".salesman__modal");
    modal.classList.add("salesman__modal--close");
  }

  function openShareModal() {
    setupSharedSalesman();
    const modal = document.querySelector(".salesman__share__modal");
    const dropdown = document.querySelector(".salesman__dropdown-options");
    dropdown.classList.add("salesman__dropdown-options--hide");
    modal.classList.remove("salesman__modal--close");
  }

  function closeShareModal() {
    const modal = document.querySelector(".salesman__share__modal");
    modal.classList.add("salesman__modal--close");
  }

  function continueToCheckout(buttonEl, event) {
    buttonEl.click();
  }

  let warningModalOpen = false;
  function openWarningModal(buttonEl, event) {
    const modal = document.querySelector(".salesman__warning__modal");
    modal.classList.remove("salesman__modal--close");
    const continueSalesmanButton = document.querySelector(
      ".salesman__warning__continue__button"
    );

    warningModalOpen = true;
    continueSalesmanButton.removeEventListener("click", continueToCheckout);
    continueSalesmanButton.addEventListener(
      "click",
      continueToCheckout.bind(null, buttonEl, event)
    );
  }

  function closeWarningModal() {
    warningModalOpen = false;
    const modal = document.querySelector(".salesman__warning__modal");
    modal.classList.add("salesman__modal--close");
  }

  function clearModalInfo() {
    const searchInput = document.querySelector(".salesman__search");
    const salesmanListElement = document.querySelector(
      ".salesman__search__list"
    );
    const salesmanListContainer = document.querySelector(
      ".salesman__search__result"
    );

    searchInput.value = "";
    salesmanListElement.innerHTML = "";
    salesmanListContainer.classList.add("salesman__search__result--hide");
  }

  function renderSalesmenResult(list) {
    const salesmanListElement = document.querySelector(
      ".salesman__search__list"
    );
    const salesmanListContainer = document.querySelector(
      ".salesman__search__result"
    );

    salesmanListContainer.classList.remove("salesman__search__result--hide");

    salesmanListElement.innerHTML = "";
    if (list.length === 0) {
      const li = document.createElement("li");
      li.innerHTML = "Ningún resultado encontrado";
      li.classList.add("no-result");
      salesmanListElement.appendChild(li);

      return;
    }
    list.forEach((salesman) => {
      const li = document.createElement("li");
      li.innerHTML = `${salesman.name}`;
      li.classList.add("card");
      li.addEventListener("click", () => {
        addSalesmanToShopifyAttribute(salesman.document, salesman.code);
        saveSalesmanToLocalStorage({
          document: salesman.document,
          name: salesman.name,
        });

        setupSalesmanSelected();
        closeSalesmanModal();
        clearModalInfo();
      });
      salesmanListElement.appendChild(li);
    });
  }

  function changeSalesman() {
    const dropdown = document.querySelector(".salesman__dropdown-options");
    dropdown.classList.add("salesman__dropdown-options--hide");

    openSalesmanModal();
  }

  function removeSalesman() {
    const dropdown = document.querySelector(".salesman__dropdown-options");
    dropdown.classList.add("salesman__dropdown-options--hide");

    addSalesmanToShopifyAttribute(undefined);
    localStorage.removeItem("salesman");
    setupSalesmanSelected(true);
  }

  function removeSalesmanAndContainer(buttonElement) {
    addSalesmanToShopifyAttribute(undefined);
    localStorage.removeItem("salesman");
    setupSalesmanSelected(true);
    const container = buttonElement.closest('.salesman__button-container');
    if (container) {
        container.remove();
    }
}
  
  document.querySelectorAll('.salesman__remove-btn').forEach(button => {
    button.addEventListener('click', function (event) {
      event.preventDefault();  
      event.stopPropagation(); 
      event.stopImmediatePropagation();
      removeSalesmanAndContainer(button);
    });
  });

  // Function to render dropdown options
  function renderDropdownOptions() {
    const dropdown = document.createElement("div");
    dropdown.classList.add(
      "salesman__dropdown-options",
      "salesman__dropdown-options--hide"
    );

    // Example options, replace with actual data
    const options = [
      {
        title: "Compartir tienda",
        action: openShareModal,
      },
      {
        title: "Cambiar vendedor",
        action: changeSalesman,
      },
      {
        title: "Remover vendedor",
        action: removeSalesman,
      },
    ];

    const dropdownList = document.createElement("ul");

    options.forEach((option) => {
      const optionElement = document.createElement("li");
      optionElement.classList.add("salesman__dropdown-option");
      optionElement.textContent = option.title;
      optionElement.addEventListener("click", option.action);
      dropdownList.appendChild(optionElement);
    });

    // Append dropdown to the button container
    const salesmanButton = document.querySelector(".salesman__button");
    dropdown.appendChild(dropdownList);
    salesmanButton.parentNode.appendChild(dropdown);

    // Hide dropdown when clicking outside
    document.addEventListener("click", function (event) {
      if (
        !dropdown.contains(event.target) &&
        !salesmanButton.contains(event.target)
      ) {
        dropdown.classList.add("salesman__dropdown-options--hide");
      }
    });
  }

  function onClickDropdown() {
    const salesmanDropdown = document.querySelector(
      ".salesman__dropdown-options"
    );
    if (salesmanDropdown) {
      salesmanDropdown.classList.toggle("salesman__dropdown-options--hide");
    }
  }

  function changeSalesmanByQuerystring() {
    const urlParams = new URLSearchParams(window.location.search);
    const salesmanDocument = urlParams.get("empresario");

    if (salesmanDocument) {
      const salesman = salesmen_array.find(
        (salesman) => salesman.document === salesmanDocument
      );
      if (salesman) {
        const currentSalesman = getSalesmanFromLocalStorage()
        if (currentSalesman && currentSalesman.document === salesman.document) return
        addSalesmanToShopifyAttribute(salesman.document);
        saveSalesmanToLocalStorage({
          document: salesman.document,
          name: salesman.name,
        });
      }
    }
  }

  function changeSalesmanByLastPurchase() {
    const selectedSalesman = getSalesmanFromLocalStorage();
    const blockGetSalesmanFromLastPurchase = localStorage.getItem(
      "blockGetSalesmanFromLastPurchase"
    );
    if (
      !selectedSalesman &&
      !blockGetSalesmanFromLastPurchase &&
      corders &&
      corders.salesman
    ) {
      const salesman = salesmen_array.find(
        (salesman) => salesman.document === corders.salesman
      );
      if (salesman) {
        saveSalesmanToLocalStorage({
          document: salesman.document,
          name: salesman.name,
        });
        localStorage.setItem("blockGetSalesmanFromLastPurchase", true);
      }
    }
  }

  function setupSalesmanSelected(ignoreQuerystring = false) {
    if (!ignoreQuerystring) {
      changeSalesmanByQuerystring();
    }

    const salesmanSelected = getSalesmanFromLocalStorage();
    const salesmanButton = document.querySelector(".salesman__button");
    if (salesmanSelected) {
      salesmanButton.innerHTML = `${salesmanSelected.name} ${caret}`;
      salesmanButton.removeEventListener("click", openSalesmanModal);
      renderDropdownOptions();
      salesmanButton.addEventListener("click", onClickDropdown);
    } else {
      salesmanButton.innerHTML = "ELIGE UN VENDEDOR";
      salesmanButton.addEventListener("click", openSalesmanModal);
      const dropdown = document.querySelector(".salesman__dropdown-options");
      if (dropdown) {
        dropdown.remove();
      }
    }
  }

  function getSalesmanFromLocalStorage() {
    const selectedSalesman = localStorage.getItem("salesman");
    if (selectedSalesman) {
      try {
        const salesman = JSON.parse(selectedSalesman);
        if (
          !Object.keys(salesman).includes("document") ||
          !Object.keys(salesman).includes("name")
        ) {
          throw new Error("Invalid salesman");
        }

        return salesman;
      } catch (error) {
        console.error("Error parsing salesman", error);
        return null;
      }
    }
    return null;
  }

  function saveSalesmanToLocalStorage(salesman) {
    localStorage.setItem("salesman", JSON.stringify(salesman));
  }

  document.addEventListener("DOMContentLoaded", () => {
    changeSalesmanByLastPurchase();
    const searchInput = document.querySelector(".salesman__search");
    const copySuccessIcon = document.querySelector(
      ".salesman__share__link .icon-success"
    );
    const closeModalButton = document.querySelector(
      ".salesman__modal__header__close"
    );
    const closeModalShareButton = document.querySelector(
      ".salesman__share__modal__header__close"
    );
    const closeModalShareButton2 = document.querySelector(
      ".salesman__share__button"
    );
    const closeModalWarningButton = document.querySelector(
      ".salesman__warning__modal__header__close"
    );
    const chooseSalesmanButton = document.querySelector(
      ".salesman__warning__choose__button"
    );

    chooseSalesmanButton.addEventListener("click", function () {
      closeWarningModal();
      openSalesmanModal();
    });

    // observe when minicart.drawer has attribute open

    const salesmanSelected = getSalesmanFromLocalStorage();

    document.addEventListener("cartdrawer:opened", () => {
      const minicartCheckoutButton = document.querySelector(
        ".mini-cart__footer .button-container button"
      );

      minicartCheckoutButton.addEventListener("click", (e) => {
        if (!salesmanSelected && !warningModalOpen) {
          e.preventDefault();
          openWarningModal(minicartCheckoutButton, e);
        }
      });
    });

    const checkoutButton = document.querySelector(".cart__checkout-button");

    if (checkoutButton) {
      checkoutButton.addEventListener("click", (e) => {
        if (!salesmanSelected && !warningModalOpen) {
          e.preventDefault();
          openWarningModal(checkoutButton, e);
        }
      });
    }

    // hide copy success icon
    copySuccessIcon.style.display = "none";

    setupSalesmanSelected();

    closeModalButton.addEventListener("click", function () {
      closeSalesmanModal();
      clearModalInfo();
    });

    closeModalShareButton.addEventListener("click", function () {
      closeShareModal();
    });
    closeModalShareButton2.addEventListener("click", function () {
      closeShareModal();
    });

    closeModalWarningButton.addEventListener("click", function () {
      closeWarningModal();
    });

    getSalesmanAttributeFromShopify();

    // search salesman by name and document when user type 3 or more characters
    searchInput.addEventListener("input", () => {
      const value = searchInput.value;
      if (value.length >= 3) {
        // debounce

        if (salesmenInputDebounce) {
          clearTimeout(salesmenInputDebounce);
        }
        salesmenInputDebounce = setTimeout(() => {
          const salesmanResult = salesmen_array.filter((salesman) => {
            return (
              salesman.name.toLowerCase().includes(value.toLowerCase()) ||
              salesman.document.includes(value)
            );
          });

          renderSalesmenResult(salesmanResult);
        }, 500);
      }
    });
  });
})();
